import { Page, View, Text } from '@react-pdf/renderer';
import { styles } from './styles';
import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '../../styles';
import { useTranslation } from 'react-i18next';
import { SafeImage } from '@composites/PDF/AgendaPdfContent/components/SafeImage';

export interface PartnerWithUsPageProps {
  event: PublicEventDetailsResponse;
  footer: JSX.Element;
}

const PartnerWithUsPage = ({ event, footer }: PartnerWithUsPageProps) => {
  const { t } = useTranslation();

  return (
    <Page
      size={{ width: 1440, height: 800 }}
      style={{ ...styles.page, overflow: 'hidden' }}
    >
      <View
        style={{
          ...styles.leftColumn,
          backgroundColor: event?.design?.themeColor,
        }}
      >
        <SafeImage
          style={styles.image}
          src={
            'https://media.we-conect.com/images/pdf/partnerprospectus/15_1.png'
          }
        />

        <SafeImage
          style={styles.peopleImage}
          src={
            'https://media.we-conect.com/images/pdf/partnerprospectus/partner_with_us_1.png'
          }
        />
      </View>

      <View style={styles.rightColumn}>
        <Text
          style={{
            ...styles.highlightedText,
            color: event?.design?.themeColor,
          }}
        >
          {t('we-have-partners-not-sponsors')}
        </Text>
        <Text style={styles.title}>{t('partner')}</Text>
        <Text style={styles.title}>{t('packages-&-pricing')}</Text>
        <View
          style={{
            ...globalStyles.lineBar,
            borderColor: event?.design?.themeColor ?? '#0F91AE',
            marginLeft: 0,
          }}
        ></View>

        <Text style={styles.about}>{t('partner-packages-&-partner-text')}</Text>
      </View>

      {footer}
    </Page>
  );
};

export default PartnerWithUsPage;
